import { render } from "./EffectsControl.vue?vue&type=template&id=5a8ac63e&scoped=true"
import script from "./EffectsControl.vue?vue&type=script&lang=js"
export * from "./EffectsControl.vue?vue&type=script&lang=js"

import "./EffectsControl.vue?vue&type=style&index=0&id=5a8ac63e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8ac63e"]])

export default __exports__